import { Messages } from "../model/Message";
import axiosCilent from "./axiosClient";
import { Result } from "../model/Result";
import jwtApi from "./Jwt.api";
import { auth } from "../firebase";
import { Company } from "../model/Companies";
import { Groups } from "../model/Groups";
import { EventParticipationHistorySearchParam } from "../model/EventParticipationHistory";

export const requestMessagesAdd = async (message:Messages): Promise<Result> => {
  try {
    const currentUser = auth.currentUser;
    return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
      .then(async (_) => {
        const response = await axiosCilent.post('add', message);
        return response.data;
      })
      .catch((rejects) => {
        return {success: false, data: rejects};
      });
  } catch (error) {
    return Promise.reject({ success: false, error });
  }
};

// お知らせ一覧取得APIリクエスト
export const requestMessageGet = async (
    authorUid: string | undefined, 
    company: Company, 
    groups: Groups[]
): Promise<Result> => {
  try{
    const response = await axiosCilent.post(`getMessageList`, {authorUid, company, groups});
    return response.data;
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};

// 予定表取得APIリクエスト
export const requestEventMessageGet = async (
    authorUid: string | undefined, 
    company: Company, 
    groups: Groups[],
    month: Date
): Promise<Messages[]> => {
  const response = await axiosCilent.post(`getEventMessageList`, {authorUid, company, groups, month});
  return response.data.data;
};

/// イベント参加履歴作成・更新・削除APIリクエスト
export const requestMunicipalityConfirmed = async (
    tenantId: string,
    messageId: string,
    isMunicipalityConfirmed: boolean
): Promise<Result> => {
  try {
    const currentUser = auth.currentUser;
    return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
      .then(async (_) => {
        const requestData = {
          tenantId: tenantId,
          messageId: messageId,
          isStaffConfirmed: undefined,
          isMunicipalityConfirmed: isMunicipalityConfirmed
        }
        const response = await axiosCilent.post(`municipalityConfirmed`, requestData);
        return {success: true, data: response.data};
      })
      .catch((rejects) => {
        return {success: false, data: rejects};
      });
  } catch (error) {
    return {success: false, data: error};
  }
}

/// ポイント履歴APIリクエスト
export const requestPointHistory = async (
    tenantId: string,
    municipalityConfirmedFlg: boolean,
    pointId: string,
    messageId: string
): Promise<Result> => {
  try {
    const currentUser = auth.currentUser;
    return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
      .then(async (_) => {
        const requestData = {
          tenantId: tenantId,
          municipalityConfirmedFlg: municipalityConfirmedFlg,
          pointId: pointId,
          messageId: messageId
        }
        const response = await axiosCilent.post(`pointHistory`, requestData);
        return response.data;
      })
      .catch((rejects) => {
        return {success: false, data: rejects};
      });
  } catch (error) {
    return {success: false, data: error};
  }
}

// 予定表取得APIリクエスト
export const requestRdbEventMessages = async (
    authorUid: string,
    tenantId: string,
    eventAtStart: Date,
    eventAtEnd: Date
): Promise<Result> => {
  try{
    const postData = { authorUid, tenantId, eventAtStart, eventAtEnd };
    const response = await axiosCilent.post(`getRdbEventMessages`, postData);
    return {
      success: true,
      data: {
        monthly_count: response.data.monthly_count ?? 0,
        data: response.data.data.rows
      }
    };
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};

// お知らせ作成者取得APIリクエスト
export const requestRdbMessageAuthorUserList = async (
    tenantId: string
): Promise<any> => {
  try{
    const postData = { tenantId };
    const response = await axiosCilent.post(`getMessageAuthorUserList`, postData);
    return response.data.data.rows;
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};

// お知らせ一覧取得APIリクエスト
export const requestRdbMessages = async (
    tenantId: string,
    tenantDisplayId: string,
    uid: string | undefined,
    pageCount: string,
    selectPage: string,
    searchCondition: any,
    deleteMessageIds: string[] = []
): Promise<Result> => {
  try{
    const postData = {
      tenantId,
      tenantDisplayId,
      uid,
      pageCount,
      selectPage,
      deleteMessageIds,
      ...searchCondition
    }
    const response = await axiosCilent.post(`getRdbMessages`, postData);
    return {
      success: true,
      data: {
        monthly_count: response.data.monthly_count ?? 0,
        data: response.data.data.rows,
        total: response.data.total
      }
    };
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};

// お知らせ配信先指定件数取得APIリクエスト
export const requestRdbMessagesDeliver = async (
    tenantId: string,
    messageId: string,
    select: string,
    pageCount: string,
    selectPage: string
): Promise<Result> => {
  try{
    const postData = {
      tenantId,
      messageId,
      select,
      pageCount,
      selectPage
    }
    const response = await axiosCilent.post(`getRdbMessagesDeliver`, postData);
    return {
      success: true,
      data: {
        rows: response.data.data.rows,
        count: response.data.aggregate
      }
    };
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};

// お知らせ返信一覧取得APIリクエスト
export const requestRdbMessagesReply = async (
    tenantId: string,
    messageId: string,
    select: string,
    pageCount: string,
    selectPage: string,
    searchConditions?: any
): Promise<Result> => {
  try{
    const postData = {
      tenantId,
      messageId,
      select,
      pageCount,
      selectPage,
      ...searchConditions
    }
    const response = await axiosCilent.post(`getRdbMessagesReply`, postData);
    return {
      success: true,
      data: {
        rows: response.data.data.rows,
        count: response.data.aggregate.rows,
        total: response.data.total
      }
    };
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};

// 予定表出欠一覧取得APIリクエスト
export const requestRdbMessagesAttendance = async (
    tenantId: string,
    messageId: string,
    select: string,
    pageCount: string,
    selectPage: string,
    searchConditions?: any
): Promise<Result> => {
  try{
    const postData = {
      tenantId,
      messageId,
      select,
      pageCount,
      selectPage,
      ...searchConditions
    }
    const response = await axiosCilent.post(`getRdbMessagesAttendance`, postData);
    return {
      success: true,
      data: {
        rows: response.data.data.rows,
        replyCount: response.data.aggregateReply.rows,
        attendanceCount: response.data.aggregateAttendance.rows,
        total: response.data.total
      }
    };
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};

// 予定表管理者数取得APIリクエスト
export const requestRdbMessagesAdminCount = async (
    messageId: string
): Promise<Result> => {
  try{
    const response = await axiosCilent.post(`getRdbMessagesAdminCount`, { messageId });
    return {
      success: true,
      data: response.data.data
    };
  } catch (error: any) {
    return {success: false, data: error}
  }
};

// 所属グループ情報取得APIリクエスト
export const requestGetRdbAttendingGroups = async (
    tenantId: string,
    select: string[] | null,
    distinct: boolean | null
): Promise<Result> => {
  try{
    const response = await axiosCilent.post(`getRdbAttendingGroups`, { tenantId, select, distinct });
    return {
      success: true,
      data: response.data.data.rows
    };
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};

// イベント参加履歴一覧取得APIリクエスト
export const requestGetRdbEventParticipationHistory = async (
    tenantId: string,
    displayTenantId: string,
    pageCount: number,
    selectPage: number,
    searchConditions: EventParticipationHistorySearchParam
): Promise<Result> => {
  try{
    const postData = {
      tenantId,
      displayTenantId,
      pageCount: pageCount < 0 ? 'NULL' : pageCount.toString(),
      selectPage: selectPage.toString(),
      messageId: searchConditions.messageId,
      replyListValue: searchConditions.replyListValue.map((value) => value.id),
      attendanceListValue: searchConditions.attendanceListValue.map((value) => value.id.replace('attendance-', '')),
      publishTarget: searchConditions.publishTarget,
      searchGroups: searchConditions.searchGroups.map((value) => value.id),
      userId: searchConditions.userId,
      lastName: searchConditions.lastName,
      title: searchConditions.title,
      eventVenue: searchConditions.eventVenue,
      sendDateStart: searchConditions.sendDateStart,
      sendDateEnd: searchConditions.sendDateEnd,
      eventAtStart: searchConditions.eventAtStart,
      eventAtEnd: searchConditions.eventAtEnd,
      eventType: searchConditions.eventType
    }
    const response = await axiosCilent.post(`getRdbEventParticipationHistory`, postData);
    return {
      success: true,
      data: {
        rows: response.data.data.rows,
        count: response.data.count
      }
    };
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};